// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';
import PetsService from '@/app/services/main/pets/pet-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'UserPetComponent',
	mixins: [
		tableMixins,
		toastMessageMixins,
		dateMixins
	],
	props: {
		petOwnerFilter: {
			type: String,
			default: ''
		}
	},
	data() {
		const statusList = [{name:'ACTIVE', value: 'ACTIVE'}, {name:'INACTIVE', value: 'INACTIVE'}];
		const genderList = [{name: 'Male', value: 'M'}, {name: 'Female', value: 'F'}];

		return {
			isBreedsAPILoading: false,
			isAPILoading: false,
			// table
			theads: [
				// { name: 'Owner', sortLabel: 'ownerName', searchLabel: 'f_owner', isDesc: false, hasSearch: true, style: null},
				{ name: 'Pet Image',isDesc: false, sortable: false },
				{ name: 'Name', sortLabel: 'petName', isDesc: false, searchLabel: 'f_petName', hasSearch: true, style: 'min-width: 137px;' },
				{ name: 'Breed', searchLabel: 'f_breedName', sortLabel: 'breedName', isDesc: false, hasBreedSearch: true },
				{ name: 'Gender', sortLabel: 'gender', isDesc: false, searchLabel: 'f_gender', hasSearchableDropdown: true, optionList: genderList },
				{ name: 'Birthday', isDesc: false, style: 'min-width: 120px !important;'},
				{ name: 'Status', sortLabel: 'status', isDesc: false, searchLabel: 'f_status', hasSearchableDropdown: true, optionList: statusList },
				{ name: 'Subscriptions', isDesc: false, style: 'min-width: 120px;'},
				{ name: 'Treatments', isDesc: false, style: 'min-width: 120px;'},
				{ name: 'Products', isDesc: false, style: 'min-width: 120px;'},
			],
			// sorting
			sortBy: 'status',
			desc: false,
			breedList: [],
			// this to get the boolean value if petOwnerFilter has a data or not
			preFilterMode: !!this.petOwnerFilter
		}
	},
	watch: {
		filterBreed() {
			this.getTableContent(true);
		}
	},
	created() {
		this.getBreedList();
		this.getTableContent();
	},
	mounted() {
		// Auto fills search field for the ownerName field
		// Might be needing this in the future

		// if (this.petOwnerFilter && this.$refs.filter_ownerName[0]) {
		// 	this.$refs.filter_ownerName[0].value = this.petOwnerFilter;
		// }
	},
	beforeDestroy() {
		this.$emit('clearPetOwnerFilters');
	},
	methods: {
		async getBreedList() {
			this.isBreedsAPILoading = true;
			const res = await BreedService.getBreeds();

			if (res.status === STATUS_CODES.SUCCESS) {
				this.breedList = res.data.data;
			} else {
				const { ERROR_GET_BREED_TITLE } = this.toastMessages.breed();
				this.showCustomErrorToast(ERROR_GET_BREED_TITLE, null, true);
			}

			this.isBreedsAPILoading = false;
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc, f_ownerEmail = this.petOwnerFilter) {
			page = fromFilter ? 1 : this.page;
			this.getPets({ page, limit, sortBy, desc, f_ownerEmail });
		},
		getPets(queryParams) {
			if (this.columnsFilter) {
				if (this.columnsFilter.f_owner) {
					queryParams['f_ownerEmail'] = this.columnsFilter.f_owner; 
				}

				if (this.columnsFilter.f_petName) {
					queryParams['f_petName'] = this.columnsFilter.f_petName; 
				}
			}

			// Only called when the component is created and has owner filters.
			if (this.preFilterMode) {
				queryParams['f_ownerEmail'] = this.petOwnerFilter;
				this.preFilterMode = false;
			}

			// search dropdown filters
			if (this.columnsFilter) {
				const {
					f_gender,
					f_status,
					f_breedName
				} = this.columnsFilter;

				if (f_gender) {
					queryParams['f_gender'] = f_gender;
				}
				if (f_status) {
					queryParams['f_status'] = f_status;
				}
				if (f_breedName) {
					const { name } = this.breedList.find(pet => pet.id === f_breedName);
					queryParams['f_breedName'] = name;
				}
			}

            this.isAPILoading = true;

			PetsService.getPets(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const parsedData =  res.data.data.map(pet => {
							const { 
								id, birthdate, breed, 
								gender, imageUrl, 
								owner: { emailAddress },
								petName, status 
							} = pet;
						
							return {
								id,
								birthday: birthdate,
								breed: breed.name,
								gender,
								imgURL: imageUrl,
								owner: emailAddress,
								petName,
								subscriptions: 1, // default coz no response from api yet
								status: status === 'A',
							}
						})
						
						this.tableContent = {
								tableData: parsedData,
								paginationData: res.data.pagination
						};
					} 
					else {
						this.showAPIErrorToast('Unable to fetch pet list.', res);
					}

				this.isAPILoading = false;
			}).catch(() => {
				this.showGenericErrorToast();
				this.isAPILoading = false;
			});
		},
		hasPetImage(petImage) {
			let image = require('@/assets/images/_shared/dog-smile.svg');

			if (petImage) {
				image = petImage;
			}

			return image;
		},
		togglePetDetailsStatus(event, pet) {
			let flag = event.target.checked;
			const alertTitle = `${flag ? 'Activate' : 'Deactivate'} Pet`;
			const alertMsg = `Are you sure you want to ${flag ? 'activate' : 'deactivate'} pet?`;

			this.$swal({
				title: alertTitle,
				text: alertMsg,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						this.callPetStatusToggleAPI(pet, flag, event);
					} else {
						event.target.checked = !flag;
					}
				});
		},
		callPetStatusToggleAPI(pet, flag, event) {
			if (flag) {
				PetsService.reactivatePet(pet.id)
					.then(res => {
						const petName = pet.petName;

						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(`Successfully reactivated ${petName}`);
							this.$refs[`ref-${pet.id}`][0].disabled = true
						} else {
							this.showAPIErrorToast(`Unable to reactivate ${petName}.`, res);
							event.target.checked = !flag;
						}
					})
					.catch(() => {
						this.showGenericErrorToast()
					});
			}
		},
		preFilterSubscriptions(pet) {
			this.$emit('setSubPreFilters', pet);
		},
		preFilterTreatments(pet) {
			this.$emit('setTreatPreFilters', pet);
		},
		preFilterProducts(pet) {
			this.$emit('setProductsPreFilters', pet);
		}
	}
}